module.exports = __webpack_public_path__ + "img/shoushi01.f6bdcfab.png";